"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstDataURLFromScreenshotsObj = getFirstDataURLFromScreenshotsObj;
/**
 * @param {object} obj
 * @return {string}
 */
function getFirstDataURLFromScreenshotsObj(obj) {
  var v = Object.values(obj || {})[0];
  if (typeof v === 'string') {
    return v;
  }
  return v ? getFirstDataURLFromScreenshotsObj(v) : '';
}